{
  "adobeExperienceCloudNoOrgsSelect": "選取其他組織帳戶",
  "adobeExperienceCloudSelectedOrg": "所選組織：{org}",
  "appSwitcherLinkOutIconLabel": "在新視窗中開啟",
  "feedback button default": "意見回饋",
  "help": "說明",
  "launchsidebar": "啟動側邊欄",
  "more actions": "更多動作",
  "searchButton": "搜尋",
  "solutionSwitcher": "切換至其他解決方案",
  "solutionSwitcherList": "應用程式清單",
  "solutionSwitcherPopover": "應用程式清單彈出視窗"
}
